var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"tim-icons icon-minimal-up top",on:{"click":function($event){return _vm.submit('asc')}}}),_c('i',{staticClass:"tim-icons icon-minimal-down bottom",on:{"click":function($event){return _vm.submit('desc')}}})])}
var staticRenderFns = []

export { render, staticRenderFns }